<ng-diagram-node-resize-adornment>
  <div
    class="group-node"
    ngDiagramGroupHighlighted
    ngDiagramNodeSelected
    [attr.data-content-id]="node()?.data?.dictionary.id"
    [attr.data-node-id]="node()?.id"
    [attr.data-node-type]="'dictionary'"
    [node]="node()"
  >
    <ng-diagram-port id="port-right" side="right" style="top: 30px" type="source" />

    <div class="group-node__header">
      <mat-icon class="ddc-content-icon">{{ icon() }}</mat-icon>
      <span class="group-node__title">{{ title() }}</span>
    </div>
    <div class="group-node__content">
      <div class="content-title">{{ node()?.data?.dictionary.title }}</div>
      <div class="content-counts">
        <ddc-element-count
          [count]="'' + (node()?.data?.dictionary.words_count ?? 0)"
          [icon]="'fiber_manual_record'"
          [size]="'small'"
        ></ddc-element-count>
        <ddc-element-count
          [count]="'' + (node()?.data?.dictionary.pairs_count ?? 0)"
          [icon]="'fiber_smart_record'"
          [size]="'small'"
        ></ddc-element-count>
      </div>
    </div>
  </div>
</ng-diagram-node-resize-adornment>
